import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

export default function useSelectedSize(): [
  string | undefined,
  (size?: string) => void
] {
  const [searchParams, setSearchParams] = useSearchParams();

  const setSelectedSize = useCallback(
    (size?: string) =>
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);

          if (size) next.set('size', size);
          else next.delete('size');

          return next;
        },
        { preventScrollReset: true, replace: true }
      ),
    [setSearchParams]
  );

  return [searchParams.get('size') ?? undefined, setSelectedSize];
}
